<template>
  <div class="card card-info" v-else>
    <div class="card-header">
      <h3 class="card-title" style="width: 100%">
        <button v-on:click="AddNew()" type="button" class=" float-left btn btn-sm btn-outline-secondary btn-default"> <i class="fa fa-plus"> Add New</i></button>
      </h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive">
            <table id="table" class="table table-bordered table-sm text-sm" width="100%">
              <thead class="bg-info">
                <tr>
                  <th>Semester</th>
                  <th>Feedback Type</th>
                  <th>Fiiled By</th>
                  <th>Admin Remarks</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, ind) in feedbackList">
                  <td>{{item.Semester}}</td>
                  <td>{{item.FeedbackType}}</td>
                  <td>{{item.FeedbackBy}}</td> 
                  <td>{{item.AdminRemarks}}</td> 
                  <td align="center" style="white-space: nowrap">
                    <div v-if="item.Attachment != null">
                      <button class="btn btn-success" v-on:click="viewFile(item.Attachment)">View Attachment</button>
                    </div> 
                    <button class="btn btn-sm btn-info" v-on:click="addRemarks(item.FeedbackID)">Remarks</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="mdlPatientRecord">
      <div class="modal-dialog ">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h4 class="modal-title">Admin Remarks</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Admin Remarks *</label>
                  <input v-model="feedback.AdminRemarks" type="text" class="form-control" />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer ">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>
            <button type="button" class="btn btn-success" v-on:click="Update()">
              Update
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

  </div>
</template>
<script>
  const axios = require('axios').default;
  export default ({
    data() {
      return {
        feedbackList: [],
        feedback: { AdminRemarks: '', FeedbackID: '' },

      }
    },
    created: function () {
      this.pageLoad();
    },
    updated: function () {
      $('#table').DataTable();
    },
    methods: { 
      pageLoad() {
        var vm = this;
        startReq();
        axios.get("/api/DCApi/feedbackList")
          .then(function (res) {
            endReq();
            if (res.data.status) {
              vm.feedbackList = res.data.lst;
            }
            else {
              toastr.error(res.data.msg);
            }
          })
          .catch(function (error) {

          });
      }, 
      addRemarks(interID) {
        var vm = this;
        axios.post("/api/DCApi/addRemarks?ID=" + interID)
          .then(function (res) {
            if (res.data.status) {
              vm.feedback = res.data.merit;
              $('#mdlPatientRecord').modal('show');
            }
            else {
              toastr.error(res.data.msg);
            }
          })
          .catch(function (error) {

          });

      },


      Update() {
        var vm = this;
        axios.post("/api/DCApi/AdminRemarks?ID=" + vm.feedback.FeedbackID + "&remarks=" + vm.feedback.AdminRemarks)
          .then(function (res) {

            toastr.success("Remarks Added");
            vm.pageLoad()
            $('#mdlPatientRecord').modal('close');


          })
          .catch(function (error) {

          });
      },
      viewFile(name) {
        var vm = this;
        startReq();
        axios.post('/api/DCApi/viewFeedbackAttachment?name=' + name)
          .then(function (res) {
            endReq();
            if (res.data.status) {
              if (res.data.format == '.pdf') {
                var pdfString = res.data.file.split(',')[1];
                let pdfWindow = window.open("");
                pdfWindow.document.write(
                  "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
                  encodeURI(pdfString) + "'></iframe>"
                );
              }
              else {
                var newTab = window.open();
                newTab.document.body.innerHTML = '<img src="' + res.data.file + '" >';
              }
            }
            else
              toastr.info(res.data.msg);
          })
          .catch(function (error) {
            console.log(error);
          });
      },

    }
  })
</script>



// WEBPACK FOOTER //
// src/components/DC/feedBackAdmin.vue